
  // by marcus ekwall
  export default function throttle2(fn, delay) {
      delay || (delay = 100);
      var throttle = false;
      return function(){
          if (throttle) { return; }
          throttle = setTimeout(function(){ throttle = false; }, delay);
          fn.apply(this, arguments);
      };
  };